import {atom} from "jotai";

const restaurantIDAtom = atom(localStorage.getItem("restaurantID") ?? -1);
const restaurantInfoAtom = atom(null);
const currencyAtom = atom("EUR");
const isAllYouCanEatAtom = atom(false);
const legalInfoExistsAtom = atom(true);

export {restaurantIDAtom, restaurantInfoAtom, currencyAtom, isAllYouCanEatAtom, legalInfoExistsAtom};